import React from 'react';

import BotReport from '../BotReport/BotReport';
import BotDashboard from '../BotReport/BotDashboard';
import AiReport from '../IaReport/IaReport';
import Historico from '../BotReport/Historico';
import BotGeneralStatus from '../BotReport/BotGeneralStatus';
import BotCustomReport from '../BotReport/BotCustomReport';
import StatusRealTime from '../BotReport/StatusRealTime';

import OrgDashboard from '../OrgReport/OrgDashboard';
import OrgBotsReport from '../OrgReport/OrgBotsReport/OrgBotsReport';
import OrgUsersReport from '../OrgReport/OrgUsersReport/OrgUsersReport';
import AuditDashboard from '../OrgReport/AuditDashboard/AuditDashboard';
import ErrorLogsDashboard from '../BotReport/ErrorLogsDashboard/ErrorLogsDashboard';
import OrgConsumption from '../OrgReport/OrgConsumption';

export const botPages = {
  DASHBOARD: 'dashboard',
  BOT: 'bot',
  AI: 'ai',
  MESSAGE_HISTORY: 'messageHistory',
  GENERAL_STATUS: 'generalStatus',
  CUSTOM_REPORT: 'customReport',
  REALTIME_STATUS: 'statusRealTime',
  ERROR_LOGS: 'errorLogs',
};

export const orgPages = {
  DASHBOARD: 'dashboard',
  BOTS: 'bot',
  USERS: 'users',
  CONSUMPTION: 'consumption',
  AUDIT: 'audit',
};

export const botsSubPages = {
  BOT_NUMBER_OF_CLIENTS: 'botNumberClients',
  BOT_NUMBER_OF_MESSAGES: 'botNumberMessages',
  BOT_NUMBER_OF_SESSIONS: 'botNumberSessions',
  BOT_NUMBER_OF_MESSAGES_BY_CHANNEL: 'botNumberMessagesByChannel',
  BOT_ATTENDANCE_TIME: 'botAttendanceTime',
  BOT_TREE_FLOW: 'botTreeFlow',
  BOT_DEMOGRAPHY: 'botDemography',
  BOT_TAGS: 'botTags',
};

export const aiSubPages = {
  AI_NOT_UNDERSTOOD: 'aiNotUnderstood',
  AI_USE_OF_INTENTIONS: 'aiUseIntentions',
  AI_INTENTION_PERFORMANCE: 'aiIntentionPerformance',
};

export const orgBotsSubPages = {
  ORG_BOTS_NUMBER: 'orgBotsNumber',
  ORG_BOTS_TOTAL_MESSAGES: 'orgBotsMessages',
  ORG_BOTS_TOTAL_MESSAGES_BY_CHANNEL: 'orgBotsMessagesByChannel',
  ORG_BOTS_TOTAL_SESSIONS: 'orgBotsSessions',
};

export const orgUsersSubPages = {
  ORG_TOTAL_USERS: 'orgTotalUsers',
  ORG_LIST_USERS: 'orgListUsers',
  ORG_BOT_USERS: 'orgBotsUser',
};

export const screenType = {
  BOT: 'bot',
  ORG: 'org',
};

const renderSoonText = (title) => {
  return (
    <div className="subtopic-text">
      {title}
      <div className="soon-text-box">
        <p className="soon-text">em breve</p>
      </div>
    </div>
  );
};

export const renderUnavailableText = (title) => {
  return (
    <div className="subtopic-text">
      {title}
      <div className="unavailable-text-box">
        <p className="unavailable-text">indisponível</p>
      </div>
    </div>
  );
};

/** Basic data for bot report */
export const botTopics = [
  {
    page: botPages.DASHBOARD,
    title: renderSoonText('Meu Dashboard'),
    released: false,
    component: (subPage) => <BotDashboard subPage={subPage} />,
    subTopics: [],
  },
  {
    page: botPages.BOT,
    title: 'Relatórios do bot',
    released: true,
    component: (subPage) => <BotReport subPage={subPage} />,
    subTopics: [
      {
        subPage: botsSubPages.BOT_NUMBER_OF_CLIENTS,
        title: 'Quant. de Clientes',
        released: true,
      },
      {
        subPage: botsSubPages.BOT_NUMBER_OF_MESSAGES,
        title: 'Quant. de Mensagens',
        released: true,
      },
      {
        subPage: botsSubPages.BOT_NUMBER_OF_SESSIONS,
        title: 'Quant. de Sessões',
        released: true,
      },
      {
        subPage: botsSubPages.BOT_NUMBER_OF_MESSAGES_BY_CHANNEL,
        title: 'Quant. Mensagens por Canal',
        released: true,
      },
      {
        subPage: botsSubPages.BOT_ATTENDANCE_TIME,
        title: 'Tempo de atendimento',
        released: true,
      },
      // {
      //   subPage: botsSubPages.BOT_TREE_FLOW,
      //   title: renderSoonText('Fluxo de Árvore'),
      //   released: false,
      // },
      {
        subPage: botsSubPages.BOT_DEMOGRAPHY,
        title: renderSoonText('Demografia'),
        released: false,
      },
      {
        subPage: botsSubPages.BOT_TAGS,
        title: 'Tags',
        released: true,
      },
    ],
  },
  {
    page: botPages.AI,
    title: 'Relatório de I.A',
    component: (subPageIa) => <AiReport subPageIa={subPageIa} />,
    released: true,
    subTopics: [
      {
        subPage: aiSubPages.AI_NOT_UNDERSTOOD,
        title: 'Não entendidas',
        released: true,
      },
      {
        subPage: aiSubPages.AI_USE_OF_INTENTIONS,
        title: 'Uso de intenções',
        released: true,
      },
      {
        subPage: aiSubPages.AI_INTENTION_PERFORMANCE,
        title: 'Desempenho de intenções',
        released: true,
      },
    ],
  },
  {
    page: botPages.MESSAGE_HISTORY,
    title: 'Histórico de mensagens',
    released: true,
    component: (subPage) => <Historico subPage={subPage} />,
    subTopics: [],
  },
  {
    page: botPages.GENERAL_STATUS,
    title: 'Status Geral',
    released: true,
    component: (subPage) => <BotGeneralStatus subPage={subPage} />,
    subTopics: [],
  },
  {
    page: botPages.REALTIME_STATUS,
    title: 'Status Real-Time',
    released: true,
    component: (subPage) => <StatusRealTime subPage={subPage} />,
    subTopics: [],
  },
  {
    page: botPages.CUSTOM_REPORT,
    title: 'Relatório Customizado',
    released: true,
    component: (subPage) => <BotCustomReport subPage={subPage} />,
    subTopics: [],
  },
  {
    page: botPages.ERROR_LOGS,
    title: 'Log de erros',
    released: true,
    component: (subPage) => <ErrorLogsDashboard subPage={subPage} />,
    subTopics: [],
  },
];

/** Basic data for orgs report */
export const orgTopics = [
  {
    page: orgPages.DASHBOARD,
    title: 'Meu Dashboard',
    released: true,
    component: (subPage) => <OrgDashboard subPage={subPage} />,
    subTopics: [],
  },
  {
    page: orgPages.BOTS,
    title: 'Bots',
    released: true,
    component: (subPage) => <OrgBotsReport subPage={subPage} />,
    subTopics: [
      {
        subPage: orgBotsSubPages.ORG_BOTS_NUMBER,
        title: 'Número de Bots',
        released: true,
      },
      {
        subPage: orgBotsSubPages.ORG_BOTS_TOTAL_MESSAGES,
        title: 'Total de Mensagens',
        released: true,
      },
      {
        subPage: orgBotsSubPages.ORG_BOTS_TOTAL_MESSAGES_BY_CHANNEL,
        title: 'Total de Mensagens por Canal',
        released: true,
      },
      {
        subPage: orgBotsSubPages.ORG_BOTS_TOTAL_SESSIONS,
        title: 'Total de Sessões',
        released: true,
      },
    ],
  },
  {
    page: orgPages.USERS,
    title: 'Usuários',
    released: true,
    component: (subPage) => <OrgUsersReport subPage={subPage} />,
    subTopics: [
      {
        subPage: orgUsersSubPages.ORG_TOTAL_USERS,
        title: 'Total de Usuários',
        released: true,
      },
      {
        subPage: orgUsersSubPages.ORG_LIST_USERS,
        title: 'List. de Usuários',
        released: true,
      },
      {
        subPage: orgUsersSubPages.ORG_BOT_USERS,
        title: renderSoonText('Bots por usuário'),
        released: false,
      },
    ],
  },
  {
    page: orgPages.CONSUMPTION,
    title: 'Consumo',
    released: true,
    component: (subPage) => <OrgConsumption subPage={subPage} />,
    subTopics: [],
  },
  {
    page: orgPages.AUDIT,
    title: 'Auditoria',
    released: true,
    component: (subPage) => <AuditDashboard subPage={subPage} />,
    subTopics: [],
  },
];
